const YoutubeIcon = (props) => (
  <svg
    width={52}
    height={48}
    viewBox="0 0 52 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={52} height={48} rx={6} fill="url(#paint0_linear_11_541)" />
    <path
      d="M33.2232 16H19.7768C17.1386 16 15 18.1025 15 20.696V27.304C15 29.8975 17.1386 32 19.7768 32H33.2232C35.8614 32 38 29.8975 38 27.304V20.696C38 18.1025 35.8614 16 33.2232 16ZM29.9927 24.3215L23.7034 27.2704C23.5358 27.3489 23.3422 27.2288 23.3422 27.0463V20.9643C23.3422 20.7792 23.5409 20.6592 23.7088 20.7429L29.9981 23.8761C30.1851 23.9692 30.1819 24.2328 29.9927 24.3215Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11_541"
        x1={1.93715e-7}
        y1={24}
        x2={52}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor={
            process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#4264AA"
          }
        />
        <stop
          offset={1}
          stopColor={
            process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#853F89"
          }
        />
      </linearGradient>
    </defs>
  </svg>
);
export default YoutubeIcon;
